import { useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

export default function FavoriteButton({ movieId }: { movieId: string }) {
  const { isFavorite, toggle } = useFavorites();
  const active = isFavorite(movieId);
  const [shared, setShared] = useState(false);

  const onShare = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch {
      /* clipboard may be unavailable */
    }
    setShared(true);
    setTimeout(() => setShared(false), 2000);
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <button
        type="button"
        onClick={() => toggle(movieId)}
        className={`flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md px-5 py-2.5 text-sm font-semibold transition-colors ${
          active
            ? "bg-accent-500 text-primary-950 hover:bg-accent-400"
            : "border border-primary-300 bg-background-50 text-primary-600 hover:bg-primary-50"
        }`}
      >
        <i className={active ? "ri-heart-fill text-lg" : "ri-heart-line text-lg"}></i>
        {active ? "已收藏" : "收藏"}
      </button>
      <button
        type="button"
        onClick={onShare}
        className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
      >
        <i className={shared ? "ri-check-line text-lg" : "ri-share-line text-lg"}></i>
        {shared ? "链接已复制" : "分享"}
      </button>
    </div>
  );
}